export default "__VITE_ASSET__403397ea__"